var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('app-layout'),_c('notification-alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }